module.exports = __webpack_public_path__ + "static/media/loader.505a8e21.svg";